module.exports = __webpack_public_path__ + "static/pieds-90fc3290d6732d5635db913c31503e69.jpg";